<template>
  <div class="recommend-wrap">
    <div class="visit-head">
      <div class="visit-head-title">
        <div class="vht-block"></div>
        <div class="vht-item">当前总数</div>
        <div class="vht-item">今日新增</div>
        <div class="vht-item">7日新增</div>
        <div class="vht-item">30日新增</div>
      </div>
      <div class="visit-head-main visit-head-maind" v-if="data">
        <div class="vhm-title">Daily Visits</div>
        <div class="vhm-item">{{ data.Daily_visits.all }}</div>
        <div class="vhm-item">{{ data.Daily_visits.today }}</div>
        <div class="vhm-item">{{ data.Daily_visits.weekly }}</div>
        <div class="vhm-item">{{ data.Daily_visits.monthly }}</div>
      </div>
      <div class="visit-head-main visit-head-mainn" v-if="data">
        <div class="vhm-title">Number of independent IP</div>
        <div class="vhm-item">{{ data.Number_of_independent_IP.all }}</div>
        <div class="vhm-item">{{ data.Number_of_independent_IP.today }}</div>
        <div class="vhm-item">{{ data.Number_of_independent_IP.weekly }}</div>
        <div class="vhm-item">{{ data.Number_of_independent_IP.monthly }}</div>
      </div>
    </div>

    <div class="visit-map">
        <div id="main"></div>
    </div>
  </div>
</template>
 
<script>
import * as echarts from "echarts";
import { getvisitdata, getvisitmap } from "@/api/visit";
export default {
  data() {
    return {
      data: null,
      xdata:[],
      ipdata:[],
      visitdata:[],
    };
  },
  mounted() {
    this.getdata();
    this.getmap();
    
  },
  methods: {
    backhome() {
      this.$router.push({
        name: "home",
      });
    },
    getdata() {
      getvisitdata().then((response) => {
          this.data = response.data;
        });
    },
    getmap() {
      getvisitmap().then((response) => {
            for(let i=0;i<response.data.Line_Chart.length;i++){
                this.xdata.push(response.data.Line_Chart[i].date);
                this.ipdata.push(response.data.Line_Chart[i].ip);
                this.visitdata.push(response.data.Line_Chart[i].visit);
            }
            this.intimap();
        });
    },
    intimap() {
      

      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "Stacked Line",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["ip", "visit"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xdata,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "ip",
            type: "line",
            // stack: "Total",
            data: this.ipdata,
          },
          {
            name: "visit",
            type: "line",
            // stack: "Total",
            data: this.visitdata,
          },
          
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
* {
  box-sizing: border-box;
}
.visit-head-title {
  width: 100%;
  display: flex;
  text-align: center;
}
.visit-head-main {
  width: 100%;
  display: flex;
  text-align: center;
  margin: 10px 0;
}
.visit-head-maind .vhm-item {
  color: coral;
}
.visit-head-mainn .vhm-item {
  color: rgb(189, 8, 8);
}
.vht-block {
  display: inline-block;
  width: 300px;
  height: 1px;
}
.vhm-title {
  display: inline-block;
  width: 300px;
  font-weight: bold;
  font-size: 20px;
}
.vht-item {
  flex: 1;
}
.vhm-item {
  flex: 1;
  font-size: 20px;
}
.recommend-wrap {
  padding: 30px;
}
.visit-head {
  width: 100%;
  border: 1px solid #e1e1e1;
  border-radius: 16px;
  padding: 10px;
}
.visit-map{
    width: 100%;
    margin-top: 30px;
}
#main{
    width: 100%;
    height: 500px;
}
</style>




// WEBPACK FOOTER //
// src/pages/visit/index.vue